import { render, staticRenderFns } from "./TopicParticipants.vue?vue&type=template&id=49d7c945&"
import script from "./TopicParticipants.vue?vue&type=script&lang=js&"
export * from "./TopicParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports